import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { RateCardsPage } from "@/features/rate-cards/pages/rate-cards-page";
import { rateCardsFilterSchema } from "@/features/rate-cards/schemas/rate-card-filter.schema";

export const Route = createFileRoute("/_authenticated/admin/rate-cards/")({
	head: () => pageTitle("Rate cards"),
	component: RateCardsPage,
	validateSearch: zodValidator(rateCardsFilterSchema),
});
